import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { updateText, updateLocationsListStyle, updateGaugleTitle, updateGaugeLabel } from 'actions/livefeed'
import update from 'immutability-helper';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';

const FontSizeDropdown = (props) => {
    const { currentEntity, dispatch } = props;

    const activeToolbarItems = currentEntity !== undefined && currentEntity.activeToolbarItems;
    const isText = currentEntity !== undefined && (currentEntity.id !== null && activeToolbarItems[2].isText);
    const [value, setValue] = React.useState(currentEntity.size)

    const fontSizeHandle = useCallback((value) => {
        const newState = update(currentEntity, {
            size: { $set: value }
        });
        typeof currentEntity.id == 'number' && dispatch(updateText(newState)) // if entity is an obj in textContainer arr
        switch (currentEntity.id) {
            case "rightPanelTextTitle":
                dispatch(updateGaugleTitle(newState))
                break;
            case "rightPanelGaugeValueLabel":
                dispatch(updateGaugeLabel(newState))
                break;
            case "locationsListStyle":
                dispatch(updateLocationsListStyle(newState));
                break;
        }

    }, [currentEntity, dispatch])

    useEffect(() => {
        setValue(currentEntity.size)
    }, [currentEntity.size])

    return (
        <div className={`justify-center font-size-dropdown-wrapper`}>
            <Dropdown
                data-tooltip="Font-size"
                className="toolbar-dropdown justify-center"
                noArrow={true}
                header={
                    <div className={`justify-center dropdown-header-text ${isText ? '' : 'dropdown-header-text_disable'}`} >
                        {isText ?
                            <input
                                name={"font-size"}
                                onChange={(e) => setValue(Number(e.target.value))}
                                value={value || currentEntity.size}
                                onBlur={e => fontSizeHandle(Number(e.target.value))}
                            />
                            :
                            <span>Font Size</span>
                        }
                        <i style={{ fontSize: "24px" }} className="material-icons">keyboard_arrow_down</i>
                    </div>
                }
                toggleable={isText}
            >

                {[...Array(41).keys()].slice(8).map(x =>
                    <React.Fragment key={x}>
                        <DropdownItem>
                            <div onClick={() => fontSizeHandle(x)}>{x}</div>
                        </DropdownItem>
                    </React.Fragment>
                )
                }
            </Dropdown>
        </div>
    );
}

FontSizeDropdown.propTypes = {
    dispatch: PropTypes.func.isRequired,
    currentEntity: PropTypes.object.isRequired
}
export default FontSizeDropdown;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/FontSizeDropdown.jsx